// ** Custom Components
import Box from "../Box"
import Container from "../Container"
import Heading from "../Heading"
import StaffCard from "../StaffCard"

const SectionTeam = ({ section }: any) => {
  const { title, listItems } = section

  return (
    <Container fullWidthOnMobile={false} constrainedToBreakPoint>
      <Heading as="h2" className="text-blue-500 text-center">
        {title}
      </Heading>
      <Box className="flex flex-wrap gap-x-6 justify-center">
        {listItems.map((staff: any, idx: any) => (
          <StaffCard staff={staff} key={idx} />
        ))}
      </Box>
    </Container>
  )
}

export default SectionTeam
